import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  SimpleChanges,
  OnDestroy
} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {constant} from '../../../app.constants';
import {T2CardComponent} from '../../../trip2-theme/components/t2-card/t2-card.component';
import {ReservationService} from '../../trip-reservations/reservations.service';
import { GoogleMapsComponent } from '../google-maps/google-maps.component';
import {Subscription} from 'rxjs/Subscription';
import { TripLocationType } from 'app/core/enums/trip-location.enum';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { MapPinResult, MapPinService } from '../map-pin-adjustment/map-pin.service';

export class LocationData {
    public locationName: string;
    public street_number: string;
    public roomaptnumber: string;
    public route: string;
    public locality: string;
    public administrative_area_level_1: string;
    public country: string;
    public postal_code: string;
    public latitude: number;
    public longitude: number;
    public phonenumber: string;
    public modifierid: string;
    public ismanualcoordinates: boolean;
    public ismanualedit: boolean;
    constructor() {}
}

@Component({
    selector: 'app-search-location-trip',
    templateUrl: './search-location-trip.component.html',
    styleUrls: ['./search-location-trip.component.scss'],
    providers: [
        MapPinService,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchLocationTripComponent ),
            multi: true
        }
    ]
})
export class SearchLocationTripComponent implements OnInit, ControlValueAccessor, OnChanges, AfterViewInit, OnDestroy {
  private observables: Subscription[] = [];
  private dataLocation: any;
    public mask = constant.MASK_PHONE;
    _value = '';
    public locationAddress: any;
    public streetaddress: any;
    public ridersInfo: any;
    public modifiers: any;
    public modifierid: any;
    public isGoogle = true;
    public triplocationid: any;
    public tripid: any;
    public isFacility = false;
    public facilitySearch = false;
    public isManualEdit = false;
    public isLocation = true;
    public isLocationString = false;
    public latitude: number;
    public longitude: number;
    protected googleResult: any;
    public searchLocationForm: FormGroup;
    public previousAddressInstance = false;
    public facilityPayorInstance = false;
    public emitAfterOnInit = false;
    public ld = new LocationData();

    @Input() roomaptnumberVal = '';
    @Input() isModifierRequired: boolean;
    @Input() address = '';
    @Input() editClass = '';
    @Input() riderId: any;
    @Input() payorId: any;
    @Input() tripLocationString: string;
    @Input() previousAddressOption = true;
    @Input() userRiderAddressOption = true;
    @Input() facilitysPayorOption = true;
    @Input() viewMobilePhone = true;
    @Input() viewHomePhone = true;
    @Input() viewAltPhone = true;
    @Input() geofences = [];
    @Input() googleOdrdGuid: string;
    @Input() maxRadiusMeters = 200;
    @Output() locData = new EventEmitter<LocationData>();
    @Output() updateLocation = new EventEmitter<any>();
    @Output() emitterData: EventEmitter<any> = new EventEmitter<any>();
    @Output() modifierHasChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() emitDataPhone: EventEmitter<{ phoneNumber?: boolean, modifier?: boolean }> = new EventEmitter();
    @Input() tripreasontransportid: number;

    phonenumber: string;
    alternatephonenumber: string;
    homephonenumber: string;
    public googleOdrdAuto: string;
    public originalAddress = null;
    public wasAddressModified = false;
    public manualAddressFields: string[] = [
        'latitude',
        'longitude',
        'location',
        'streetaddress',
        'roomaptnumber',
        'city',
        'state',
        'zip',
        'county'
    ];
    public componentLocation = {
        street_number : 'short_name',
        route         : 'short_name',
        locality      : 'short_name',
        administrative_area_level_1: 'short_name',
        country       : 'long_name',
        postal_code   : 'short_name'
    };
    private lastAddressFormValues = null;

    public zoom: number;
    arrayPhone = [];

    private readonly iconPU = 'assets/images/marker/marker-accepted.svg';
    private readonly iconDP = 'assets/images/marker/marker-active-do.svg';

    @ViewChild('search') public searchElementRef: ElementRef;
    @ViewChild('previousAddressesModal') public previousAddressesModal: T2CardComponent;
    @ViewChild('facilitysPayorModal') public modalFacilitysPayor: T2CardComponent;
    @ViewChild('map') public map: GoogleMapsComponent;
    @ViewChild('mapPinModal') public mapPinModal: T2CardComponent;

    propagateChange: any = () => {};

    constructor(
        private fb: FormBuilder,
        private service: ReservationService,
        private toastrAlertHelper: ToastrAlertHelper,
        private sweetAlertHelper: SweetAlertHelper,
        private mapPinService: MapPinService,
        ) {
        this.createSearchForm();
        this.setupAddressModifiedTracking();
        this.modifierRequired();
    }

    /**
     * @description
     */
    ngOnInit() {
        // this.newGetLocation();
        this.loadModifiers();
        this.requiredAndDisabledInput();
        this.isLocationString = this.tripLocationString != null;
        this.subscribeToMapPinResult();
    }
    ngAfterViewInit() {
      this.emitAfterOnInit = true;
    }
    /**
     * @description
     */
    ngOnChanges(changes: SimpleChanges): void {
      this.modifierRequired();
      if (changes['roomaptnumberVal']) {
        this.roomaptnumberVal = changes['roomaptnumberVal'].currentValue;
        this.searchLocationForm.patchValue({
          roomaptnumber: changes['roomaptnumberVal'].currentValue
        });
      }

      if (changes['googleOdrdGuid']) {
        this.googleOdrdAuto = changes['googleOdrdGuid'].currentValue;
      }

      if (changes['tripreasontransportid'] && this.tripreasontransportid) {
        this.loadModifiersByReason(this.tripreasontransportid);
      }
    }

    /**
     * @description
     */
    modifierRequired() {
        if (this.isModifierRequired) {
            this.searchLocationForm.get('modifierid').setValidators(Validators.required);
        } else {
            this.searchLocationForm.get('modifierid').clearValidators();
            this.searchLocationForm.patchValue({modifierid: null});
            this.searchLocationForm.updateValueAndValidity();
        }
    }
    /**
     * THIS METHOD FIRES AFTER CLICK USE RIDER ADDRESS LINK AND CALLS AFTER SUCCESS loadRider() METHOD
     */
    onUseRiderAddres() {
      this.observables.push(
      this.service.loadRider(this.riderId).subscribe(
            data => {
                this.loadRiderInfo(data);
            }));
    }
    /**
     * THIS METHOD OPEN THE MODAL OF THE PREVIOUS ADDRESSES
     */
    onPreviousAddress($event) {
        this.previousAddressesModal.open($event);
    }
    /**
     * @description Este metodo se invico cuando desde el modal se previousAddressesModal se selecciona un row del grid
     * @param $event
     */
    onSelectPreviousAddresses($event) {
        this.phonenumber = this.searchLocationForm.get('phonenumber').value;
        this.alternatephonenumber = this.searchLocationForm.get('alternatephonenumber').value;
        this.homephonenumber = this.searchLocationForm.get('homephonenumber').value;
        this.searchLocationForm.reset();
        this.previousAddressesModal.close();
        this.onLoadModifier($event.modifierid);
        this.onPatchValue($event, true);
    }
    /**
     * @description
     * @param $event
     */
    onSelectFacilityPayor($event) {
        $event.location = $event.location ? $event.location : $event.description;
        this.searchLocationForm.reset();
        this.modalFacilitysPayor.close();
        this.onPatchValue($event, true);
    }
    /**
     * THIS METHOD OPEN THE MODAL OF FACILITY�S PAYOR
     */
    onFacilitysPayor(event) {
        this.modalFacilitysPayor.open(event);
    }
    /**
     * THIS METHOD LOADS RIDER INFO INTO REACTIVE FORM
     * @param riderInfo
     */
    loadRiderInfo(riderInfo) {
        riderInfo.triplocationid = this.triplocationid;
        riderInfo.tripid = this.tripid;
        this.phonenumber = this.searchLocationForm.get('phonenumber').value;
        this.alternatephonenumber = this.searchLocationForm.get('alternatephonenumber').value;
        this.homephonenumber = this.searchLocationForm.get('homephonenumber').value;
        this.searchLocationForm.reset();
        this.isFacility = riderInfo.isfacility;
        this.onLoadModifier(17);
        this.onPatchValue(riderInfo, true);
    }
    /**
     * THIS METHOD IS LOADED IN ngOnInit() METHOD AND SET REQUIRED THE FILLS IN IT
     */
    requiredAndDisabledInput() {
        this.searchLocationForm.get('latitude').setValidators(Validators.required);
        this.searchLocationForm.get('longitude').setValidators(Validators.required);
        this.searchLocationForm.get('location').setValidators(Validators.required);
        this.searchLocationForm.get('city').setValidators(Validators.required);
        this.searchLocationForm.get('state').setValidators(Validators.required);
        this.searchLocationForm.get('zip').setValidators(Validators.required);
        this.searchLocationForm.get('county').setValidators(Validators.required);
    }
    /**
     * THIS METHOD LOAD THE MODIFIERS
     */
    loadModifiers() {
      this.observables.push(
        this.service.getTripModifiers().subscribe(
            data => {
                this.modifiers = data;
            }));
    }

    loadModifiersByReason(tripreasontransportid: number) {
      this.observables.push(
        this.service.getTripModifiersByReason(tripreasontransportid).subscribe((data: any) => {
          if (data && data.length) {
            this.modifiers = data;
            this.onSelectModifier();
            this.emitDataPhone.emit({modifier: true});
          }
        }, error => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            text: error.message,
            type: 'error'
          });
        })
      );
    }

    /**
     * THIS METHOD IS CALLED IN ngOnInit() METHOD AND CREATES THE REACTIVE FORM
     *
     */
    createSearchForm() {
        this.searchLocationForm = this.fb.group({
            latitude: '',
            longitude: '',
            location: '',
            streetaddress: '',
            roomaptnumber: '',
            city: '',
            state: '',
            zip: '',
            phonenumber: '',
            homephonenumber: '',
            alternatephonenumber: '',
            modifierid: '',
            modifierDesc: '',
            isfacility: false,
            triplocationid: 0,
            tripid: 0,
            county: '',
            ismanualcoordinates: false,
            ismanualedit: false
        });
    }
    getModel() {
        return {
            'latitude': '',
            'longitude': '',
            'location': '',
            'streetaddress': '',
            'roomaptnumber': '',
            'city': '',
            'state': '',
            'zip': '',
            'phonenumber': '',
            'alternatephonenumber': '',
            'homephonenumber': ''
        };
    }
    writeValue(value: any) {
        if (value) {
            this.triplocationid = value.triplocationid;
            this.tripid = value.tripid;
            this.phonenumber = value.phonenumber ? value.phonenumber : '';
            this.alternatephonenumber = value.alternatephonenumber ? value.alternatephonenumber : '';
            this.homephonenumber = value.homephonenumber ? value.homephonenumber : '';
            this.onPatchValue(value, true);
          this.onLoadModifier(value.modifierid === 0 ? null : value.modifierid);
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
        this.emitterData.emit(fn);
    }

    registerOnTouched(fn: () => void): void { };

    /**
     * THIS METHOD SENDS THE ID OF THE SELECTED SEARCH OPTION
     */
    onSelectedBtn(event) {
        switch (event) {
            case 0:
                this.isGoogle = true;
                this.facilitySearch = false;
                this.isManualEdit = false;
                this.isLocation = true;
                break;
            case 1:
                this.isGoogle = false;
                this.facilitySearch = true;
                this.isManualEdit = false;
                this.isLocation = true;
                break;
            case 2:
                this.isGoogle = false;
                this.facilitySearch = false;
                this.isFacility = false;
                this.isManualEdit = true;
                this.isLocation = false;
                break;
        }
    }
    onSelectFacilty(event) {
        this.searchLocationForm.reset();
        this.onPatchValue(event, true);
        this.onLoadModifier(event.modifierid);
    }
    onLoadModifier(modifierId) {
      if (modifierId) {
        this.searchLocationForm.patchValue({ modifierid: modifierId });
      }
    }

  /**
   * @description
   * @param value
   * @param isSelection
   */
  onPatchValue(value: any, isSelection: boolean = false): void {
    if (value) {
      const values = {
        latitude: value.latitude,
        longitude: value.longitude,
        location: value.location === undefined ? value.location : value.location,
        streetaddress: value.streetaddress,
        roomaptnumber: (value && value.roomaptnumber) ? value.roomaptnumber : (this.roomaptnumberVal || null),
        city: value.city,
        state: value.state,
        zip: value.zip,
        phonenumber: value.phonenumber ? value.phonenumber : this.phonenumber,
        alternatephonenumber: value.alternatephonenumber ? value.alternatephonenumber : this.alternatephonenumber,
        homephonenumber: value.homephonenumber ? value.homephonenumber : this.homephonenumber,
        isfacility: this.isFacility,
        triplocationid: this.triplocationid,
        tripid: this.tripid,
        modifierDesc: value.modifier ? value.search : '',
        county: value.county ? value.county : '',
        ismanualcoordinates: value.ismanualcoordinates === true,
        ismanualedit: !!value.ismanualedit
      };

      if (isSelection) {
        this.originalAddress = JSON.parse(JSON.stringify(values));
      }

      this.validateGeofence(value, values);

      if (isSelection) {
        const incomingManualEdit = values.ismanualedit === true;
        this.wasAddressModified = incomingManualEdit;
        this.searchLocationForm.patchValue(
          {ismanualedit: incomingManualEdit},
          {emitEvent: false}
        );

        this.emitterData.emit(values);
      }
    }
  }

  get hasValidCoordinates(): boolean {
    const form = this.searchLocationForm;
    if (!form) { return false; }
    const latCtrl = form.get('latitude');
    const lngCtrl = form.get('longitude');
    return lngCtrl.value && latCtrl.value;
  }

  get isTripContext(): boolean {
    return !!this.tripLocationString;
  }

  get isManualCoordinates(): boolean {
    const ctrl = this.searchLocationForm ? this.searchLocationForm.get('ismanualcoordinates') : null;
    return ctrl ? ctrl.value === true : false;
  }

  get tittleManualCoordinates(): string {
    const prefix = 'Edit coordinates manually';
    return this.isManualCoordinates
      ? `${prefix} (Coordinates was edited manually)`
      : `${prefix} (Coordinates was provided by Google)`;
  }

  get isAddressModified(): boolean {
    return this.wasAddressModified;
  }

  private hasAddressChanges(): boolean {
    const current = this.searchLocationForm && this.searchLocationForm.value;
    const fieldsToCompare = [
      'location',
      'streetaddress',
      'city',
      'state',
      'zip',
      'county',
      'latitude',
      'longitude',
      'roomaptnumber'
    ];

    return fieldsToCompare.some(field => {
      const currentVal = current && current[field];
      const originalVal = this.originalAddress && this.originalAddress[field];
      if (field === 'latitude' || field === 'longitude') {
        return Number(currentVal) !== Number(originalVal);
      }
      return this.normalizeValue(currentVal) !== this.normalizeValue(originalVal);
    });
  }

  private normalizeValue(value: any): any {
    return value || '';
  }

  private setupAddressModifiedTracking(): void {
    this.observables.push(
      this.searchLocationForm.valueChanges.subscribe(() => {
        if (this.didAddressFieldValueChange()) {
          this.wasAddressModified = this.computeIsAddressModified();
          this.searchLocationForm.patchValue(
            { ismanualedit: this.wasAddressModified },
            { emitEvent: false }
          );
          this.propagateChange(this.searchLocationForm.value);
          this.emitterData.emit(this.searchLocationForm.value);
        }
        this.captureLastAddressFormValues();
      })
    );
  }

  private didAddressFieldValueChange(): boolean {
    const current = this.searchLocationForm && this.searchLocationForm.value;
    if (!this.lastAddressFormValues || !current) { return true; }
    return this.manualAddressFields.some(function (field) {
      var currentVal = current[field];
      var previousVal = this.lastAddressFormValues[field];
      if (field === 'latitude' || field === 'longitude') {
        return Number(currentVal) !== Number(previousVal);
      }
      var normalizedCurrent = currentVal || '';
      var normalizedPrevious = previousVal || '';
      return normalizedCurrent !== normalizedPrevious;
    }.bind(this));
  }

  private captureLastAddressFormValues(): void {
    if (!this.searchLocationForm) { return; }
    this.lastAddressFormValues = Object.assign({}, this.searchLocationForm.value);
  }

  private captureOriginalAddressSnapshot(): void {
    if (!this.searchLocationForm) {
      this.originalAddress = null;
      return;
    }
    const formValue = this.searchLocationForm.value;
    const hasData = this.manualAddressFields.some(function (field) {
      const val = formValue[field];
      return !!val;
    });
    if (hasData) {
      this.originalAddress = JSON.parse(JSON.stringify(formValue));
    } else {
      this.originalAddress = null;
    }
  }

  private computeIsAddressModified(): boolean {
    if (!this.searchLocationForm) {
      return false;
    }

    const manualEditCtrl = this.searchLocationForm.get('ismanualedit');
    if (manualEditCtrl && manualEditCtrl.value === true) {
      return true;
    }

    if (!this.originalAddress) {
      return this.manualAddressFields.some(field => {
        const ctrl = this.searchLocationForm.get(field);
        if (!ctrl) { return false; }
        const val = ctrl.value;
        return !!val;
      });
    }

    return this.hasAddressChanges();
  }

  onAdjustOnMap(): void {
    const lat = this.searchLocationForm.get('latitude').value;
    const lng = this.searchLocationForm.get('longitude').value;
    if (lat == null || lng == null) { return; }

    const icon = this.tripLocationString === TripLocationType.DropOff ? this.iconDP : this.iconPU;

    this.mapPinModal.open();

    this.mapPinService.configure({
      latitude: lat,
      longitude: lng,
      locationName: this.tripLocationString,
      markerIcon: icon,
      maxRadiusMeters: this.maxRadiusMeters
    });
  }

  private subscribeToMapPinResult(): void {
    this.observables.push(
      this.mapPinService.result$.subscribe({
        next: (result: MapPinResult) => {
          if (result && result.locationName !== this.tripLocationString) {
            return;
          }

          if (result) {
            this.mapPinModal.close();

            const {latitude, longitude} = result;

            const wasManualEdit = this.wasAddressModified;
            const manualEditCtrl = this.searchLocationForm.get('ismanualedit');
            const wasManualEditForm = manualEditCtrl ? manualEditCtrl.value : false;

            if (this.originalAddress) {
              this.originalAddress.latitude = latitude;
              this.originalAddress.longitude = longitude;
            }

            this.searchLocationForm.patchValue({
              latitude,
              longitude,
              ismanualcoordinates: true
            });

            this.validateGeofence(result, this.searchLocationForm.value);
            this.loadAddress();

            this.wasAddressModified = wasManualEdit;
            this.searchLocationForm.patchValue(
              { ismanualedit: wasManualEditForm },
              { emitEvent: false }
            );

            this.propagateChange(this.searchLocationForm.value);
          }
        }
      })
    );
  }

  private validateGeofence(
    value: any,
    values: any,
    isSelection = false
  ): void {
    const lat = this.searchLocationForm.get('latitude').value;
    const lon = this.searchLocationForm.get('longitude').value;
    const exceptions =
      (value.latitude == 25.76489219999999 && value.longitude == -80.2583114) ||
      (value.latitude == 25.7712156 && value.longitude == -80.25504479999999);

    if (this.geofences) {
      this.map.fillGeoFences(this.geofences);
      const isOnGeofenceRange =
        this.geofences.length === 0 ||
        (this.geofences.length > 0 &&
          this.map.isOnGeofences(
            this.map.latLng(value.latitude, value.longitude)
          ));
      if (isOnGeofenceRange || exceptions) {
        this.roomaptnumberVal = value.roomaptnumber;
        this.searchLocationForm.patchValue(values);
        this.loadAddress();
        if (lat !== value.latitude || lon !== value.longitude) {
          if (this.emitAfterOnInit) {
            this.updateLocation.emit(true);
          }
        }
        this.propagateChange(this.searchLocationForm.value);
        this.emitterData.emit(values);
      } else {
        this.toastrAlertHelper.error(
          'This location is not inside the payor working area'
        );
        this.clearAllFields();
      }
    }
  }

  loadAddress() {
    const location = this.searchLocationForm.get('location').value;
    const city = this.searchLocationForm.get('city').value;
    const state = this.searchLocationForm.get('state').value;
    const zip = this.searchLocationForm.get('zip').value;
    const county = this.searchLocationForm.get('county').value;
    const streetaddress = this.searchLocationForm.get('streetaddress').value;
    if (streetaddress) {
      this.locationAddress = streetaddress + this.validateCommaChar(streetaddress) +
      city + this.validateCommaChar(city) +
      state + this.validateCommaChar(state) +
      zip + this.validateCommaChar(zip) +
      county;
    }
    if (location) {
      this.streetaddress = location;
    }
  }
  setLocationName(value) {
    this.searchLocationForm.get('location').setValue(value);
    this.onChangepropagate(value, false);
  }

  /**
   * Validation if comma is necessary
   * @param field
   */

  getLengthPhon(data: string): void {
    const clearData =  data.replace(/[^0-9]/g, '').length;
    if (data && clearData < 10) {
      this.arrayPhone.push(clearData);
    }
  }

  validatePhone(phonenumber: string, alternatephonenumber: string, homephonenumber: string): void {
    if (phonenumber) {
      this.getLengthPhon(phonenumber);
    }
    if (alternatephonenumber) {
      this.getLengthPhon(alternatephonenumber);
    }
    if (homephonenumber) {
      this.getLengthPhon(homephonenumber);
    }
    if (this.arrayPhone && this.arrayPhone.length) {
      this.arrayPhone.filter((item) => {
        if (item < 10) {
          this.emitDataPhone.emit({phoneNumber: true});
        }
      });
    } else {
      this.emitDataPhone.emit({phoneNumber: false});
    }
  }

  validateCommaChar(field) {
      return (field !== '' && field !== null ) ? ', ' : '';
    }
  onChangepropagate(event, facility?, modifier?) {
      this.searchLocationForm.patchValue({
        roomaptnumber: this.roomaptnumberVal
      });
      const formSearch = Object.assign({}, this.searchLocationForm.value);
      const { phonenumber, alternatephonenumber, homephonenumber } = formSearch;
      this.arrayPhone = [];
      this.validatePhone(phonenumber, alternatephonenumber, homephonenumber);
        this.searchLocationForm.patchValue({
            triplocationid          : this.triplocationid !== undefined ? this.triplocationid : null,
            tripid                  : this.tripid !== undefined ? this.tripid : null
        });
        if ( this.isLocation || modifier) { this.onSelectModifier(); }
        if ( !this.isLocation || facility ) {
            this.searchLocationForm.patchValue({
                isfacility: this.isFacility
            });
        };

    if (this.searchLocationForm.valid) {
        this.validateGeofence(formSearch, formSearch, false);
      }
        if (modifier) {
          this.onChangeModifier();
        }
    }

  onSelectModifier() {
    const modifierid = this.searchLocationForm.get('modifierid').value;
    const result = this.modifiers.find(item => modifierid === item.modifierid);
    if (result) {
      this.searchLocationForm.patchValue({
        modifierDesc: result.description
      });
    } else {
      this.searchLocationForm.get('modifierid').setValue(null);
    }
  }

    onChangeModifier() {
      this.modifierHasChanged.emit(true);
    }

  clearAllFields(): void {
    this.streetaddress = null;
    this.locationAddress = null;
    this.searchLocationForm.reset();
    this.isFacility = false;
    this.isLocationString = false;
    this.latitude = null;
    this.longitude = null;
    this.triplocationid = null;
    this.tripid = null;
    this.modifierid = null;
    this.googleResult = null;
    this.arrayPhone = [];
    this.ridersInfo = null;
    this.isGoogle = true;
    this.facilitySearch = false;
    this.isManualEdit = false;
    this.isLocation = true;
    this.previousAddressInstance = false;
    this.facilityPayorInstance = false;

    this.propagateChange(null);
    this.emitterData.emit(null);
    this.emitDataPhone.emit({ phoneNumber: false, modifier: false });
  }

  onMapPinModalClose($event: { isOpen: boolean, isMinimized: boolean }): void {
    if (!$event.isOpen) {
      this.mapPinService.dismiss();
    }
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/search-location-trip/search-location-trip.component.ts